import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: ${spaceMixin('lg')};
    padding-top: ${spaceMixin('sm')};
    margin: -${spaceMixin('xs')};
`;

export const StyledCol = styled.div`
    flex: 1;
    max-width: 320px;
    margin: ${spaceMixin('xs')};
`;
